__turbopack_context__.v({
  "branch": "SiteTree-module__6moJ7G__branch",
  "branchItem": "SiteTree-module__6moJ7G__branchItem",
  "caret": "SiteTree-module__6moJ7G__caret",
  "label": "SiteTree-module__6moJ7G__label",
  "leaf": "SiteTree-module__6moJ7G__leaf",
  "link": "SiteTree-module__6moJ7G__link",
  "list": "SiteTree-module__6moJ7G__list",
  "root": "SiteTree-module__6moJ7G__root",
  "row": "SiteTree-module__6moJ7G__row",
  "summary": "SiteTree-module__6moJ7G__summary",
  "summaryLabel": "SiteTree-module__6moJ7G__summaryLabel",
});
